module.exports = __webpack_public_path__ + "img/clock.a3655ce6.svg";